<template>
  <div id="conexaoCaixaVinculoPerfis">
    <div class="text-body2">
      Escolha qual perfil da Caixa pertence a <strong>esta</strong> empresa.
    </div>
    <div class="text-caption text-grey-6 q-mt-xs">
      A escolha é definitiva: para trocar depois é preciso desconectar e refazer.
    </div>

    <div v-if="carregandoPerfis" class="text-center q-mt-md">
      <q-spinner color="blue-7" size="3em" />
    </div>

    <div v-else-if="!perfis.length" class="q-mt-md text-grey-7">
      Nenhum perfil disponível no momento.
    </div>

    <q-list v-else separator class="q-mt-md">
      <q-item
        v-for="item in perfis"
        :key="item.perfil"
        :clickable="item.disponivel"
        :disable="!item.disponivel || selecionando"
        @click="abrirConfirmacao(item)"
      >
        <q-item-section>
          <q-item-label :class="item.disponivel ? '' : 'text-grey-6'">
            {{ item.perfil }}
          </q-item-label>
        </q-item-section>
        <!-- Nunca dizer de QUEM e o perfil: so que nao esta disponivel. -->
        <q-item-section side v-if="!item.disponivel">
          <span class="text-caption text-grey-6">Indisponível</span>
        </q-item-section>
      </q-item>
    </q-list>

    <div class="row items-center justify-between q-mt-md">
      <q-btn
        flat dense no-caps
        color="grey-7"
        label="Começar de novo"
        :disable="selecionando"
        @click="$emit('recomecar')"
      />
      <q-btn
        flat no-caps
        color="primary"
        label="Atualizar lista"
        :loading="carregandoPerfis"
        :disable="carregandoPerfis || selecionando"
        @click="carregarPerfis"
      />
    </div>

    <q-dialog v-model="dialogConfirmacao" persistent>
      <q-card style="min-width: 320px; max-width: 420px">
        <q-card-section>
          <div class="text-subtitle1">Confirmar escolha</div>
          <div class="text-body2 q-mt-sm">
            Vincular esta empresa ao perfil <strong>{{ perfilPendente }}</strong>?
          </div>
          <div class="text-caption text-grey-7 q-mt-sm">
            A escolha é definitiva. Para usar outro perfil será preciso desconectar e
            refazer a configuração.
          </div>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat no-caps label="Cancelar" color="grey-8" :disable="selecionando" @click="dialogConfirmacao = false" />
          <q-btn
            no-caps
            label="Confirmar"
            color="green"
            :loading="selecionando"
            :disable="selecionando"
            @click="confirmarPerfil"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "ConexaoCaixaVinculoPerfis",

  emits: ["atualizado", "desconectar", "recomecar"],

  data() {
    return {
      dialogConfirmacao: false,
      perfilPendente: null,
    };
  },

  computed: {
    ...mapGetters([
      "conexaoCaixaPerfis",
      "conexaoCaixaPerfisLoading",
      "conexaoCaixaVinculoLoading",
    ]),

    perfis()          { return this.conexaoCaixaPerfis; },
    carregandoPerfis(){ return this.conexaoCaixaPerfisLoading; },
    selecionando()    { return this.conexaoCaixaVinculoLoading; },
  },

  mounted() {
    this.carregarPerfis();
  },

  methods: {
    ...mapActions(["fetchConexaoCaixaPerfis", "selecionarConexaoCaixaPerfil"]),

    async carregarPerfis() {
      const res = await this.fetchConexaoCaixaPerfis();
      // Erro ja esta no getter conexaoCaixaVinculoErro; o orquestrador exibe.
      if (!res.ok) this.$emit("atualizado");
    },

    abrirConfirmacao(item) {
      if (!item.disponivel) {
        this.$q.notify({
          message: "Este perfil não está disponível. Escolha outro da lista.",
          color: "orange",
          position: "top-right",
        });
        return;
      }
      this.perfilPendente = item.perfil;
      this.dialogConfirmacao = true;
    },

    async confirmarPerfil() {
      const perfil = this.perfilPendente;
      const res = await this.selecionarConexaoCaixaPerfil(perfil);
      this.dialogConfirmacao = false;

      if (!res.ok) {
        this.$q.notify({ message: res.erro.mensagem, color: "red", position: "top-right" });

        if (res.erro.acao === "recarregar_perfis") {
          await this.carregarPerfis();
        } else if (res.erro.acao === "desconectar") {
          this.$emit("desconectar");
        }
        return;
      }

      this.$q.notify({
        message: "Perfil vinculado a esta empresa.",
        color: "green",
        position: "top-right",
      });
      this.$emit("atualizado");
    },
  },
};
</script>
